// Auto-generated enum file
// Generated by model:types command

export enum TaxType {
  Normal = 'normal',
  Inclusive = 'inclusive',
  Compound = 'compound',
  Fixed = 'fixed',
  Withholding = 'withholding',
}
